<template>
	<div class="refundPage">
	    <p class="tips">当前可退余额<span>￥{{money}}</span>请确保以下表单信息填写真实正确，方便退款到您的开户卡</p>
		<div class="pub_list">
			<div class="tit">开户姓名：</div>
			<div class="pub_list_bd">
				<input type="text" v-model="name" />
			</div>
		</div>
		<div class="pub_list">
			<div class="tit">开户行：</div>
			<div class="pub_list_bd">
				<input type="text" v-model="cardName" />
			</div>
		</div>
		<div class="pub_list">
			<div class="tit">开户卡号：</div>
			<div class="pub_list_bd">
				<input type="number" v-model="cardNumber" />
			</div>
		</div>
		<div class="long-btn" @click="submit">确 定</div>
		
		<!--提示框-->
		<v-tips :isshow="tipshow" :tips="tips"></v-tips>
	</div>
</template>

<script>
	import vTips from "../../common/tip"
	import api from "../../api/api"
	
	export default {
		data () {
			return {
				tipshow:false,
				tips:'',
				docno:'',
				name:'',
				cardName:'',
				cardNumber:'',
				money:0
			}
		},
		components:{vTips},
		mounted(){
			api.getrefund({},(res) => {
				if(res.status == 1){
					this.docno = res.data.refundCard.DOCNO;	
					this.money = res.data.refundCard.RETPAYAMT;	
				}else{
					api.tipload(this,res.msg);
				}
			});
		},
		methods: {
			submit() {
				if(this.name == ''){
					api.tipload(this,"请输入您的开户姓名");
					return false;
				}else if(this.cardName == ''){
					api.tipload(this,"请输入您的开户行名称");
					return false;
				}else if(this.cardNumber == ''){
					api.tipload(this,"请输入您的开户卡号");
					return false;
				};
				
				const params = {
					docno:this.docno,
					accountName:this.name,
					bankName:this.cardName,
					accountNo:this.cardNumber
				};
				console.log("params",params);
				api.refundsubmit(params,(res) => {
					api.tipload(this,res.msg);
					if(res.status == 1){
						setTimeout(() => {
							this.$router.go(-1);
						},1500);	
					}
				});
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/refund/refund.vue